import { STALE_TIME } from 'business/constants';
import { useQueryGetData } from 'hooks/getData';
import { mergeDashboardFilters } from 'routes/Explore/components/Sentence/helpers';
import { ChartDataQueryPayload } from '../ChartContainer';
import {
    ChartMaxValueQueryPayload,
    useGetMaxValueFromEndpoint,
} from './maxValue';

const getExploreChartFilters = (
    chartFilters: QueryFilterT[],
    dashboardFilters: QueryFilterT[],
): Array<QueryFilterT | QueryFilterT> =>
    chartFilters.filter(
        (f) =>
            !dashboardFilters
                .map((extraFilter) => extraFilter.field)
                .includes(f.field),
    );

export const useGetExploreChartData = (payload: ChartDataQueryPayload) => {
    const {
        queryMetrics,
        queryDimensions,
        queryFilters,
        extraFilters,
        cacheKey,
        enabled,
    } = payload;

    const chartFilters = queryFilters
        ? getExploreChartFilters(queryFilters, extraFilters)
        : [];
    const query: QueryT = {
        metrics: queryMetrics,
        dimensions: queryDimensions,
        filters: chartFilters,
        // We add dashboard filters here so we can differentiate those in the backend
        // an API update should allow us to add this information directly in the serialize
        // string of the filter, rather than creating a separate list (like we do now)
        dashboardFilters: extraFilters,
    };

    return useQueryGetData(query, cacheKey, {
        enabled: query.metrics.length > 0 && enabled,
        staleTime: STALE_TIME,
    });
};

export const useGetExploreChartMaxValue = (
    payload: ChartMaxValueQueryPayload,
) => {
    const {
        metrics,
        filters,
        maxValueField,
        disableDashboardFilters,
        dashboardFilters,
    } = payload;
    const metric: QueryMetricT | undefined =
        metrics && metrics.length > 0 && maxValueField
            ? {
                  field: maxValueField,
                  aggregation: metrics[0].aggregation,
              }
            : undefined;
    const maxValueQuery: QueryT = {
        metrics: metric ? [metric] : [],
        dimensions: [],
        filters: !disableDashboardFilters
            ? mergeDashboardFilters(dashboardFilters ?? [], filters ?? [])
            : (filters ?? []),
    };

    return useGetMaxValueFromEndpoint(
        payload,
        maxValueQuery,
        'query/get_data/v2',
        metric,
        disableDashboardFilters,
        dashboardFilters,
    );
};
